import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useTenant } from "../hooks";

const LevelContext = React.createContext();

export const UserLevelProvider = ({ children }) => {
  const [chart_account_level_limit, setchart_account_level_limit] = useState(0);
  const [cost_center_level_limit, setcost_center_level_limit] = useState(0);
  const [LevelId , SetLevelId] = useState(null); 
  const BaseUrl = process.env.REACT_APP_INV_API_SERVER_BASE_URL;
  const { tenantId, companySelected } = useTenant();
  const GetLevel = useCallback(async () => {
    try {
      const level = await axios.post(`${BaseUrl}/setting/get-all`, {
        tenant_id: tenantId,
        company_id: companySelected?.value,
      });
      setchart_account_level_limit(
        level?.data?.data?.chart_account_level_limit || 0,
      );
      setcost_center_level_limit(
        level?.data?.data?.cost_center_level_limit || 0,
      );
      SetLevelId(level?.data?.data?.id);
    } catch (e) {
      console.log(e);
    }
  });
  useEffect(() => {
    GetLevel();
  }, [tenantId, companySelected?.value]);
  return (
    <LevelContext.Provider
      value={{
        chart_account_level_limit,
        cost_center_level_limit,
        LevelId,
        GetLevel
      }}
    >
      {children}
    </LevelContext.Provider>
  );
};
export default LevelContext;